import { GoalsCreatorOrModifierUser } from './lib/hooks/useQueryGoalsCreatorsAndModifiers';
import { Goal } from './types';

export const getUserAuditData = (
  { createdAt, createdBy: creatorId, updatedAt: modifiedAt, updatedBy: updaterId }: Goal,
  userInfoLookup: { [key: string]: GoalsCreatorOrModifierUser },
) => {
  const creator = userInfoLookup[creatorId];
  const createdBy = { emailAddress: creatorId, ...creator };

  let modifiedBy;
  if (updaterId) {
    const modifier = userInfoLookup[updaterId];
    modifiedBy = { emailAddress: updaterId, ...modifier };
  }

  return { createdBy, createdAt, modifiedBy, modifiedAt };
};
